import React from "react";

function About() {
  return (
    <div className="main-about-page">
      <h6 className="about-page-content">
        Welcome to GaanvWaale, your destination for authentic Indian flavors!
        Experience the vibrant tastes of Indian villages with our handpicked
        teas, aromatic spices, and mouthwatering burgers. Discover a world of
        tea, sourced from India's finest estates. From robust Assam to delicate
        Darjeeling, our teas offer an unforgettable experience. Our spices,
        directly sourced from local farmers, capture the true essence of India.
        Explore fragrant cumin, coriander, turmeric, and more. Indulge in our
        fusion burgers, inspired by regional Indian flavors. Locally sourced
        ingredients and traditional techniques ensure a delicious feast. Our
        knowledgeable team is ready to assist you in choosing the perfect tea or
        spice. Explore our menu and let us awaken your senses. GaanvWaale's
        product brings the authentic tastes of Indian villages to your doorstep.
        Join us on a flavorful journey today!
      </h6>
    </div>
  );
}

export default About;
